import { Avatar } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { tokens } from "styles/Tokens";
import { getInitials, getLoggedInUserDetails } from "utils/CommonFunctions";
import { getResolvedUserDisplayName } from "utils/SharedUtils";
import Typography from "../Typography";
import { colorProps } from "./colorProps";
import { variantProp } from "./variantProp";

interface Props {
  variant?: string;
  size?: string;
  user: any;
  index?: any;
  sizeProperty?: any;
  colorProperty?: any;
  zIndex?: number;
}

function AvatarItem(props: Props) {
  const { user, index, sizeProperty, colorProperty, variant, size, zIndex } = props;
  const loggedInUser = getLoggedInUserDetails(true);
  const [sizeProp, setSizeProp] = React.useState<any>();
  const [colorProp, setColorProp] = React.useState<any>();

  const avatarSrcStyle = {
    width: sizeProperty ? sizeProperty?.width : sizeProp?.width,
    height: sizeProperty ? sizeProperty?.height : sizeProp?.height
  };

  const avatarColorStyle = {
    width: sizeProperty ? sizeProperty?.width : sizeProp?.width,
    height: sizeProperty ? sizeProperty?.height : sizeProp?.height,
    background: colorProperty ? colorProperty?.bgColor : colorProp?.bgColor,
    color: colorProperty ? colorProperty?.textColor : colorProp?.textColor,
    border: colorProperty ? colorProperty?.borderStyle : colorProp?.borderStyle
  };

  useEffect(() => {
    setSizeProp(variantProp[size ?? "large"]);
    setColorProp(colorProps[variant ?? "colored"]);
  }, []);

  if (user?.src) {
    return (
      <Avatar
        key={index}
        sx={{
          ...avatarSrcStyle,
          zIndex,
          "&.MuiAvatar-root": {
            border: `1px solid ${tokens.Border.General.Inverse}`
          }
        }}
        src={user.src}
      />
    );
  }

  const isUnresolved = !isEmpty(user) && isEmpty(getResolvedUserDisplayName(user));

  return (
    <Avatar
      key={user.id}
      sx={{
        ...avatarColorStyle,
        ...(isUnresolved && { border: `1px solid ${tokens.Border.Feedback.Alert}` }),
        zIndex,
        ".MuiAvatarGroup-root &.MuiAvatar-root": {
          border: isUnresolved
            ? `1px solid ${tokens.Border.Feedback.Alert}`
            : colorProperty?.borderStyle || colorProp?.borderStyle
        }
      }}
      className="new-avatar"
    >
      <Typography
        sx={{ fontSize: sizeProperty?.fontSize || sizeProp?.fontSize }}
        variant="body2"
        showBold
        color={isUnresolved ? tokens.Text.Feedback.Alert : undefined}
      >
        {!isEmpty(user) ? getInitials(user) : getInitials(loggedInUser)}
      </Typography>
    </Avatar>
  );
}

export default AvatarItem;
